import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../content/SiteContext';
import { whatsappLink } from '../lib/contact';
import { PageMeta, PageHero, SectionHead, CtaBand, Icon, AppButton } from '../components/ui';

const Locations = () => {
  const { CITIES } = useSite();
  return (
  <>
    <PageMeta
      title="Mobile Car Wash Service Areas | Abu Dhabi & Dubai | Quick Way"
      description="Quick Way mobile car wash serves Abu Dhabi and Dubai, including Yas Island, Al Reem, Khalifa City, Dubai Marina, Downtown and Dubai Hills."
      path="/locations"
      crumbs={[{ name: 'Locations', path: '/locations' }]}
    />
    <PageHero eyebrow="Service areas" title="Where Quick Way washes cars">
      <p>We currently serve Abu Dhabi and Dubai. Send your exact location when you book and we will confirm coverage for your address.</p>
    </PageHero>

    <section className="section">
      <div className="container">
        <div className="grid grid-2">
          {CITIES.map((c) => (
            <article key={c.id} className="city-card city-card--static">
              <span className="icon-tile"><Icon name="pin" /></span>
              <h2>{c.name}</h2>
              <p>Areas we regularly serve include:</p>
              <ul className="area-list">
                {(c.areas || []).map((a) => <li key={a}>{a}</li>)}
              </ul>
              <Link to={c.path} className="btn btn-outline-dark">Mobile car wash in {c.name}</Link>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="section section--tint">
      <div className="container">
        <SectionHead title="Where we can wash your car">
          The same packages and prices apply in every area we serve.
        </SectionHead>
        <div className="grid grid-3">
          <div className="feature">
            <span className="icon-tile"><Icon name="home" /></span>
            <h3>Villas and townhouses</h3>
            <p>We usually wash in your driveway or outside your gate. Add gate or visitor-access details to your booking so the team is not held at the entrance.</p>
          </div>
          <div className="feature">
            <span className="icon-tile"><Icon name="building" /></span>
            <h3>Residential towers</h3>
            <p>Share the building name, parking level and bay. Some buildings restrict car washing in their car parks, so check with building management first.</p>
          </div>
          <div className="feature">
            <span className="icon-tile"><Icon name="car" /></span>
            <h3>Offices and business districts</h3>
            <p>Get your car cleaned while you work. Tell us the car park, level and bay so you do not need to come down.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container container--narrow">
        <SectionHead title="Check coverage and book in the app">
          Pin your exact location in the <Link to="/car-wash-app">Quick Way app</Link> and our team confirms whether we can reach you before your booking is final.
          You can compare <Link to="/pricing">car wash prices</Link> or read about our <Link to="/services/exterior-car-wash">exterior wash</Link>,{' '}
          <Link to="/services/interior-car-cleaning">interior cleaning</Link> and <Link to="/services/car-detailing">detailing</Link> services first.
        </SectionHead>
        <p className="center-note"><AppButton label="Get the app" className="btn btn-primary" source="locations" /></p>
      </div>
    </section>

    <section className="section section--tint">
      <div className="container container--narrow">
        <SectionHead title="Outside Abu Dhabi and Dubai?">
          We do not yet serve Sharjah, Ajman, Umm Al Quwain, Ras Al Khaimah or Fujairah.
          If your area is not listed above, <a href={whatsappLink('Hi Quick Way, do you cover my area? My location is: ')} target="_blank" rel="noopener noreferrer">ask us on WhatsApp</a> and we will tell you whether we can reach you.
        </SectionHead>
      </div>
    </section>

    <CtaBand source="locations" />
  </>
);
};

export default Locations;
